var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.report.panel",
  title: "Artisan Panel",
  description: "Reusable panel shell for Application Artisan Report sections.",
  styling: {
    styles: [
      {
        selector: ".app-artisan-panel",
        styles: [
          "backdrop-filter: blur(1.3rem);",
          "background: linear-gradient(180deg, rgba($background-color, 0.9) 0%, rgba($background-color, 0.8) 100%);",
          "border: 0.0625rem solid rgba($secondary, 0.22);",
          "border-radius: 1.75rem;",
          "box-shadow: 0 1.5rem 3rem rgba($background-color, 0.22);",
          "display: flex;",
          "flex-direction: column;",
          "gap: 1rem;",
          "padding: 1.2rem;",
          "transition: transform 0.5s ease, border-color 0.5s ease, box-shadow 0.5s ease, opacity 0.7s ease;",
          "opacity: 0;",
          "transform: translateY(1.2rem) scale(0.985);"
        ]
      },
      {
        selector: ".app-artisan-panel.is-visible",
        styles: [
          "opacity: 1;",
          "transform: translateY(0) scale(1);"
        ]
      },
      {
        selector: ".app-artisan-panel:hover",
        styles: [
          "border-color: rgba($primary, 0.28);",
          "box-shadow: 0 1.8rem 3.4rem rgba($background-color, 0.28);",
          "transform: translateY(-0.18rem);"
        ]
      },
      {
        selector: ".app-artisan-panel-head",
        styles: [
          "align-items: flex-start;",
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.75rem;",
          "justify-content: space-between;"
        ]
      },
      {
        selector: ".app-artisan-panel-title",
        styles: [
          "font-size: 1.05rem;",
          "font-weight: 700;",
          "margin: 0;"
        ]
      },
      {
        selector: ".app-artisan-panel-copy",
        styles: [
          "color: rgba($text-color, 0.88);",
          "font-size: 1rem;",
          "line-height: 1.65;",
          "margin: 0;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-panel",
        styles: [
          "border-radius: 1.25rem;"
        ]
      }
    ]
  },
  fields: {
    title: {
      type: "string",
      required: true,
      title: "Title",
      description: "Panel title."
    },
    description: {
      type: "string",
      title: "Description",
      description: "Panel description."
    },
    inner: {
      type: "inner",
      required: true,
      title: "Inner",
      description: "Panel body."
    },
    class: {
      type: "string",
      title: "Class",
      description: "Optional extra class name."
    }
  }
});

exports.render = async function renderPanel(options) {
  return {
    n: "section",
    c: "app-artisan-panel" + (options.class ? " " + options.class : ""),
    "data-artisan-pop": "true",
    i: [
      {
        n: "div",
        c: "app-artisan-panel-head",
        i: [
          {
            n: "h2",
            c: "app-artisan-panel-title",
            i: options.title
          },
          options.description ? {
            n: "p",
            c: "app-artisan-panel-copy",
            i: options.description
          } : ""
        ]
      },
      options.inner
    ]
  };
};
